import { Subject } from 'rxjs';
import { OverlayRef } from '@angular/cdk/overlay';
import { TemplateRef, Type } from '@angular/core';
import { NavigationEnd, Router, RouterEvent, Event } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface OverlayCloseEvent<R> {
  type: 'backdropClick' | 'close';
  data: R;
}

// R = Response Data Type, T = Data passed to Modal Type
export class MyOverlayRef<R = any, T = any> {
  afterClosed$ = new Subject<OverlayCloseEvent<R>>();

  constructor(
    public overlay: OverlayRef,
    public content: string | TemplateRef<any> | Type<any>,
    public data: T & { eventType?: { modalMode?: string } }, // pass data to modal i.e. FormData
    public style: any = null,
    public closeOnBackdrop: boolean,
    private router: Router,
    private overlayList: any[] = [],
  ) {
    const appContainer = document.getElementById('app-container');
    if (appContainer) {
      let bobyHeight = appContainer.offsetHeight;
      let bodyWidth = appContainer.offsetWidth;

      if (closeOnBackdrop != false) {
        overlay.backdropClick().subscribe(() => this._close('backdropClick', undefined));
      }
      this.router.events.pipe(filter((e: Event | RouterEvent): e is RouterEvent => e instanceof NavigationEnd)).subscribe((val: any) => {
        this.close();
      });

      if (data['eventType']?.['modalMode'] == 'floatting') {
        let overlayShift = 40 * this.overlayList.length;
        overlay.overlayElement.setAttribute(
          'style',
          'position : fixed !important ; top : ' + (bobyHeight * 0.25 + overlayShift) + 'px; left : ' + (bodyWidth * 0.3 + overlayShift) + 'px',
        );
      }

      //allways set of overlay on top
      let topZIndex = 1100;
      let nodeOverlayPane = document.getElementsByClassName('cdk-overlay-pane');
      for (let i = 0; i < nodeOverlayPane.length; i++) {
        let node: any = nodeOverlayPane[i];
        if (+node.style.zIndex > topZIndex) {
          topZIndex = +node.style.zIndex;
        }
      }
      overlay.overlayElement.style.zIndex = topZIndex.toString();
    }
  }

  public close(data?: R, ref: any = null) {
    console.log('ref', ref?.overlay?.id);
    let matchingOverlayIndex = this.overlayList.findIndex((overlayInstance) => {
      return overlayInstance.id == ref?.overlay?.id;
    });
    if (matchingOverlayIndex > 0) {
      this.overlayList.splice(matchingOverlayIndex, 1);
    }
    this._close('close', data);
  }

  private findPositionForNewOverlay() {}

  private _close(type: 'backdropClick' | 'close', data: any) {
    this.overlay.dispose();
    this.afterClosed$.next({
      type,
      data,
    });
    this.afterClosed$.complete();
  }
}
